import React from 'react';
import PropTypes from 'prop-types';

import { Tab as MUITab } from '@mui/material';

export const Tab = props => <MUITab {...props} />;

Tab.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.node,
  value: PropTypes.any,  // eslint-disable-line react/forbid-prop-types
  wrapped: PropTypes.bool
};

export default Tab;
